import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FontIcon from 'material-ui/FontIcon';
import IconButton from 'material-ui/IconButton';
import ActionEdit from 'material-ui/svg-icons/editor/mode-edit';
import ActionRemove from 'material-ui/svg-icons/action/delete';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import { Table, TableHeader, TableBody, TableRow, TableRowColumn, TableHeaderColumn } from 'material-ui/Table';
import FlatButton from 'material-ui/FlatButton';

import QualityControlQuestionDialog from '../QualityControlQuestionDialog';
import { showDialog, hideDialog, isDialogOpen } from '../../actions/dialogs';

import styles from './styles';

const QUESTION_TYPES = [
  {
    code: 'YN',
    name: 'Yes/No',
    description: 'Request user to confirm a specified action',
  }, {
    code: 'PH',
    name: 'Upload Image',
    description: 'Request user to upload image as evidence',
  },
];

const getType = (code) => {
  return QUESTION_TYPES.find((type) => type.code === code);
};

const getTypeName = (code) => {
  return getType(code) ? getType(code).name : 'Unknown';
};

class QuestionsTable extends Component {
  static propTypes = {
    questions: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,

    dialogs: PropTypes.object.isRequired,
    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
  };

  state = {};

  componentWillMount() {
  }

  handleSave = (question) => {
    console.log('handleSave', question);
    if (!question) {
      return;
    }

    let found = false;
    const questions = this.props.questions.map((q) => {
      if (question.id === q.id) {
        found = true;
        return question;
      }

      return q;
    });

    if (!found) {
      questions.push(question);
    }

    this.props.onChange(questions);
  };

  handleAdd = () => {
    this.handleEdit({});
  };

  handleEdit = (question) => {
    this.props.showDialog('qualityControlQuestion', { question });
  };

  handleRemove = (question) => {
    const context = {
      type: 'warning',
      title: 'Remove Quality Control Question?',
      message: 'Are you sure you wish to remove this question?',
      buttons: [
        <FlatButton
          label="Cancel"
          onClick={() => this.props.hideDialog('confirm')}
        />,
        <FlatButton
          label="Remove"
          onClick={() => {
            this.props.hideDialog('confirm');

            this.props.onChange(this.props.questions.filter((r) => r.id !== question.id));
          }}
        />,
      ],
    };

    this.props.showDialog('confirm', context);
  };

  renderQuestion = (question) => {
    return (<TableRow key={question.id}>
      <TableRowColumn style={styles.questionCol}>{question.question}</TableRowColumn>
      <TableRowColumn style={styles.typeCol}>{ getTypeName(question.type) }</TableRowColumn>
      <TableRowColumn style={styles.mandatoryCol}>{ question.mandatory ? 'Yes' : 'No' }</TableRowColumn>
      <TableRowColumn style={styles.actionCol}>
        <IconButton
          tooltip="Edit"
          tooltipPosition="bottom-center"
          onClick={() => this.handleEdit(question)}>
          <ActionEdit />
        </IconButton>
        <IconButton
          tooltip="Remove"
          tooltipPosition="bottom-center"
          onClick={() => this.handleRemove(question)}>
          <ActionRemove />
        </IconButton>
      </TableRowColumn>
    </TableRow>);
  };

  renderAdd() {
    return (<div>
        <FloatingActionButton
          style={styles.addQuestion}
          onClick={this.handleAdd} secondary>
          <ContentAdd />
        </FloatingActionButton>

        { isDialogOpen(this.props.dialogs, 'qualityControlQuestion') ? <QualityControlQuestionDialog
          onSave={this.handleSave}/> : null }
      </div>
    );
  }

  render() {
    const questions = this.props.questions || [];
    if (questions.length === 0) {
      return (<div style={styles.noQuestionsContainer}>
        <FontIcon className="material-icons" style={styles.noQuestions}>playlist_add_check</FontIcon>
        <div>No quality control questions have been added. Click on the "Add" button to add some</div>
        { this.renderAdd() }
      </div>);
    }

    return (<div>
        <Table selectable={false} multiSelectable={false}>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn style={styles.questionCol}>Question</TableHeaderColumn>
              <TableHeaderColumn style={styles.typeCol}>Type</TableHeaderColumn>
              <TableHeaderColumn style={styles.mandatoryCol}>Mandatory</TableHeaderColumn>
              <TableHeaderColumn style={styles.actionCol}></TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            { questions.map(this.renderQuestion) }
          </TableBody>
        </Table>

        { this.renderAdd() }
      </div>
    );
  }
}

// export default QuestionsTable;

function mapStateToProps(state) {
  return {
    // jobProfile: state.get('jobprofiles').get('jobProfile').toJS(),
    // initialValues: state.get('jobprofiles').get('jobProfile').toJS(),
    dialogs: state.get('dialogs').get('dialogs').toJS(),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    hideDialog,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionsTable);



// WEBPACK FOOTER //
// ./src/components/QuestionsTable/index.js